import { render } from "./GeoFencingDisplay.vue?vue&type=template&id=8bc23588"
import script from "./GeoFencingDisplay.vue?vue&type=script&lang=js"
export * from "./GeoFencingDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__